// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {  CreateDeviceRegistrationCommand, DeviceRegistrationDto } from './types'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'


// Define a service using a base URL and expected endpoints
export const notificatonsApi = createApi({
  reducerPath: 'notificatonsApi',
  tagTypes: ['deviceRegistrations'],
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.notificationsAPiUrl,
    prepareHeaders: async (headers, { getState }) => {
      return await getHeaders(ApiScope,headers);
    }
  }),
  endpoints: (builder) => ({
    createDeviceRegistration: builder.mutation<DeviceRegistrationDto, CreateDeviceRegistrationCommand>({
      query: (args) => ({
        url: `deviceRegistration`,
        method: 'post',
        body: args
      }),
      invalidatesTags: ['deviceRegistrations']
    }),
    deleteDeviceRegistration: builder.mutation<void, string>({
      query: (deviceId) => ({
        url: `deviceRegistration/${deviceId}`,
        method: 'delete',
      }),
      invalidatesTags: ['deviceRegistrations']
    }),

  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateDeviceRegistrationMutation,
  useDeleteDeviceRegistrationMutation
} = notificatonsApi